"use client";
import { Link } from "@cappelendamm/design-system/react";
import classNames from "classnames";
import { IndexDocument } from "@cappelendamm/catalogue/meilisearch/search-index-receiver.js";
import { useRouter, useSearchParams } from "next/navigation";
import { useCallback, useMemo } from "react";
import { useItemListing } from "./ItemListingContext";
import { FACETS } from "../constants";

export const NAV_FACETS: {
  label: string;
  attribute: "itemType" | "all";
  value: IndexDocument["itemType"] | string;
}[] = [
  { label: "Alle treff", attribute: "all", value: "" },
  { label: "Bøker", attribute: "itemType", value: "book" },
  { label: "Abonnementer", attribute: "itemType", value: "subscription" },
  { label: "Bokpakker", attribute: "itemType", value: "product-bundle" },
  { label: "Verk", attribute: "itemType", value: "literary-work" },
  { label: "Serier", attribute: "itemType", value: "series" },
  { label: "Artikler", attribute: "itemType", value: "article" },
];

const { queryParam, attribute } = FACETS["itemType"];

export function ItemTypeNavigationTabs() {
  const router = useRouter();
  const { facets, nbHits } = useItemListing();
  const searchParams = useSearchParams();

  // Get selected type from URL
  const selectedType = useMemo(() => {
    return (
      searchParams.get(queryParam) || searchParams.get(attribute) || undefined
    );
  }, [searchParams]);

  const handleTypeChange = useCallback(
    (value: string) => {
      const params = new URLSearchParams(searchParams);
      if (value) {
        params.set(queryParam, value);
      } else {
        params.delete(queryParam);
      }
      router.replace(`?${params.toString()}`, { scroll: false });
    },
    [router, searchParams],
  );

  return (
    <nav className="col-span-full w-full overflow-x-auto border-b border-gray-300">
      <ul className="flex gap-4">
        {NAV_FACETS.map(({ label, attribute, value }) => {
          const isRefined =
            attribute === "all" ? !selectedType : selectedType === value;

          const count =
            attribute === "all"
              ? nbHits
              : facets["itemType"]?.find((facet) => facet.value === value)
                  ?.count;

          if (!count) return null;

          return (
            <li key={`${attribute}-${value}`}>
              <Link
                as="button"
                type="button"
                onClick={() =>
                  handleTypeChange(attribute === "all" ? "" : `${value}`)
                }
                variant="menu"
                className={classNames(
                  "min-w-fit p-0 whitespace-nowrap decoration-2 underline-offset-[1rem]",
                  {
                    "font-semibold underline decoration-(--cvr-button-background)":
                      isRefined,
                  },
                )}
              >
                {`${label} (${count})`}
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
